import React from "react";

export default function Terms() {
  return (
    <div className="content">
      <h1>Terms & Conditions</h1>
      {/* <p><strong>Last Updated:</strong> [DATE]</p> */}

      <p>
        Welcome to Smart Clinic, operated by <strong>Siara PVT LTD</strong>
        (“we”, “our”, “us”). By using our mobile application, you agree to
        follow the terms outlined below. If you do not agree, please stop using
        the App.
      </p>

      <h2>1. Use of the App</h2>
      <p>
        Smart Clinic provides medical appointment management, health record
        storage, and communication features. You must use the App responsibly
        and only for lawful purposes.
      </p>

      <h2>2. User Accounts</h2>
      <ul>
        <li>You must provide accurate information while creating an account.</li>
        <li>You are responsible for keeping your login details secure.</li>
        <li>We may suspend accounts that violate these Terms.</li>
      </ul>

      <h2>3. Medical Information</h2>
      <p>
        Smart Clinic stores sensitive health-related data. The App does not
        replace professional medical advice. Always consult a qualified doctor
        for medical decisions.
      </p>

      <h2>4. Restrictions</h2>
      <ul>
        <li>You may not misuse or attempt to hack the App.</li>
        <li>You may not upload harmful, illegal, or misleading content.</li>
        <li>You may not impersonate another person.</li>
      </ul>

      <h2>5. Data Privacy</h2>
      <p>
        Your data is handled according to our <strong>Privacy Policy</strong>.
        By using the App, you agree to the collection and use of your data as
        described there.
      </p>

      <h2>6. App Availability</h2>
      <p>
        We aim to keep Smart Clinic available at all times, but we do not
        guarantee uninterrupted service. Maintenance, updates, or technical
        issues may cause downtime.
      </p>

      <h2>7. Limitation of Liability</h2>
      <p>
        We are not responsible for:
      </p>
      <ul>
        <li>any misuse of the App,</li>
        <li>any loss caused by inaccurate user data,</li>
        <li>any medical decisions taken without consulting a doctor.</li>
      </ul>

      <h2>8. Changes to Terms</h2>
      <p>
        We may update these Terms at any time. Continued use of the App means
        you accept the updated Terms.
      </p>

      <h2>9. Contact Us</h2>
      <p>If you have questions about these Terms, contact us at:</p>
      <p><strong>Email:</strong> siaramarketingpvtltdofficial@gmail.com</p>
      <p><strong>Company:</strong> Siara PVT LTD</p>
    </div>
  );
}
